import Headroom from "headroom.js"

const mainHeader = document.querySelector(".m-header")

export const mobileQuery = window.matchMedia("(max-width: 61.999em)") // Change to your needs

const closers = document.querySelectorAll(".--js-main-nav-closer")
const openers = document.querySelectorAll(".--js-main-nav-opener")

export const closeMenu = (event?: Event) => {
  event?.preventDefault()
  mainHeader?.classList.remove("--open")
}

const openMenu = (event: Event) => {
  event.preventDefault()
  mainHeader?.classList.add("--open")
}

closers.forEach((closer) => {
  closer.addEventListener("click", closeMenu)
})
openers.forEach((opener) => {
  opener.addEventListener("click", openMenu)
})

const headRoomHeaderOptions: Headroom.HeadroomOptions = {
  offset: mainHeader?.clientHeight ?? 0,
}

export const headRoomHeader = mainHeader ? new Headroom(mainHeader, headRoomHeaderOptions) : null

if (headRoomHeader) headRoomHeader.init()
